export class TubeRackValidationRequest {

    materialBarcode: string;

    carrierRef: string;

    carrierBarcode: string;

    positionCol: number;

    positionRow: number;

    removeMaterial: boolean;

    labId: string;
}
